import axios, { AxiosInstance } from 'axios';
import { convertSnakeToCamel } from '@/utils';
import mock from '@/../mocks/$mock';

const baseDomain = import.meta.env.VITE_API_BASE_DOMAIN;
const baseURL = `${baseDomain}`;

export const apiAxiosClientController = new AbortController();
const signal = apiAxiosClientController.signal;

/**
 * バックエンドAPI 接続用 Axios インスタンス
 */
const repository: AxiosInstance = axios.create({ baseURL, signal });
if (import.meta.env.MODE === 'mock') {
  mock(repository).setDelayTime(500); // モック化
  console.log('[Axios Mock Server] enabled');
}

const __DEBUG__ = import.meta.env.MODE !== 'prod';

repository.interceptors.request.use(async (request) => {
  if (__DEBUG__) {
    console.debug(`# Req: [${request.method?.toUpperCase()}] ${request.url}`, request.data);
  }

  return request;
});

repository.interceptors.response.use(
  (response) => {
    if (__DEBUG__) {
      console.debug(
        `[${response.config.method?.toUpperCase()}] ${response.config.url} => ${response.status}`,
        convertSnakeToCamel(response.data)
      );
    }

    if (response.data) {
      convertSnakeToCamel(response.data);
    }

    return response;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default repository;
